import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "alert alert-warning d-flex align-items-start gap-3 mb-3"
}
const _hoisted_2 = {
  key: 4,
  class: "toast-container position-fixed bottom-0 end-0 p-3"
}
const _hoisted_3 = {
  class: "toast show",
  role: "status"
}
const _hoisted_4 = { class: "toast-body d-flex align-items-center gap-3" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "d-flex gap-2" }
const _hoisted_7 = {
  key: 0,
  class: "badge rounded-pill text-bg-light ms-2"
}
const _hoisted_8 = {
  key: 1,
  class: "badge rounded-pill text-bg-primary ms-2"
}
const _hoisted_9 = {
  key: 0,
  class: "badge rounded-pill text-bg-primary ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalculationOverlay = _resolveComponent("CalculationOverlay")!
  const _component_DescriptionSourcesPanel = _resolveComponent("DescriptionSourcesPanel")!
  const _component_FoundValuesDialog = _resolveComponent("FoundValuesDialog")!
  const _component_EstimateForm = _resolveComponent("EstimateForm")!
  const _component_RecalculationDialog = _resolveComponent("RecalculationDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showCalculatingOverlay)
      ? (_openBlock(), _createBlock(_component_CalculationOverlay, {
          key: 0,
          failed: _ctx.calculationFailed,
          retrying: _ctx.retrying,
          onRetry: _ctx.retryWithLlm,
          onCalculateWithoutLlm: _ctx.calculateWithoutLlm,
          onClose: _ctx.closeOverlay
        }, null, 8, ["failed", "retrying", "onRetry", "onCalculateWithoutLlm", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.aiFallbackUsed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("span", { class: "fas fa-exclamation-triangle mt-1" }, null, -1),
          _createElementVNode("div", null, [
            _createElementVNode("strong", null, "AI výběr srovnávacích nemovitostí nebyl použit."),
            _createTextVNode(" Pro spuštění AI Asistenta vám nezbývají AI kredity, proto byl pro tento výpočet použit standardní algoritmus. Doplnit kredity můžete v sekci Nákup AI kreditů. ")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.created)
      ? (_openBlock(), _createBlock(_component_DescriptionSourcesPanel, {
          key: 2,
          ref: "sourcesPanel",
          "sources-client": _ctx.sourcesClient,
          "initial-attachments": _ctx.estimate.attachments,
          "load-attachments": _ctx.loadAttachments,
          onSourcesChanged: _ctx.onSourcesChanged,
          onShowFoundValues: _ctx.openFoundValues
        }, null, 8, ["sources-client", "initial-attachments", "load-attachments", "onSourcesChanged", "onShowFoundValues"]))
      : _createCommentVNode("", true),
    (_ctx.created)
      ? (_openBlock(), _createBlock(_component_FoundValuesDialog, {
          key: 3,
          ref: "foundValuesDialog",
          "save-handler": _ctx.saveFoundValues,
          onClosed: _ctx.onFoundValuesClosed,
          onShowSegment: _cache[0] || (_cache[0] = path => _ctx.estimateForm?.showSegment(path))
        }, null, 8, ["save-handler", "onClosed"]))
      : _createCommentVNode("", true),
    (_ctx.foundToastShown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fas fa-check-circle text-success" }, null, -1)),
              _createElementVNode("div", _hoisted_5, " Podklady jsou zpracované, " + _toDisplayString(_ctx.foundCounts.new) + " " + _toDisplayString(_ctx.plural(_ctx.foundCounts.new, 'nová hodnota', 'nové hodnoty', 'nových hodnot')) + ". ", 1),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openFoundValues(null)))
              }, "Zobrazit"),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "aria-label": "Zavřít",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.foundToastShown = false))
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_EstimateForm, {
      ref: "estimateForm",
      onSave: _ctx.onSegmentSave,
      estimate: _ctx.estimate,
      "segment-configurations-factory": _ctx.createSegmentConfiguration
    }, _createSlots({ _: 2 }, [
      (_ctx.created)
        ? {
            name: "actions",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                (_ctx.foundCounts.total > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(["btn d-inline-flex align-items-center px-3 text-nowrap", _ctx.foundCounts.new > 0 ? 'btn-primary' : 'btn-outline-primary description-sources-button']),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openFoundValues(null)))
                    }, [
                      _cache[7] || (_cache[7] = _createTextVNode(" Hodnoty z podkladů ", -1)),
                      (_ctx.foundCounts.new > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.foundCounts.new) + " nové", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.foundCounts.total), 1))
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary description-sources-button d-inline-flex align-items-center px-3 text-nowrap",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sourcesPanel?.show()))
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "fas fa-magic me-2" }, null, -1)),
                  _cache[9] || (_cache[9] = _createTextVNode("Vyplnit s pomocí AI ", -1)),
                  (_ctx.sourceCount > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.sourceCount), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["onSave", "estimate", "segment-configurations-factory"]),
    _createVNode(_component_RecalculationDialog, {
      "recalculation-handler": () => _ctx.model.recalculateWithNewEstates(),
      ref: "recalculationDialog"
    }, null, 8, ["recalculation-handler"])
  ]))
}